import { get } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { CreditCard } from '@generated-types';

export const getCreditCardsList = async () => get<CreditCard[]>(`${KREDITTBANKEN_BASE_URL}/credit-cards`);
